import { render, staticRenderFns } from "./Socket.vue?vue&type=template&id=79e48414&scoped=true&"
import script from "./Socket.vue?vue&type=script&lang=js&"
export * from "./Socket.vue?vue&type=script&lang=js&"
import style0 from "./Socket.vue?vue&type=style&index=0&id=79e48414&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e48414",
  null
  
)

export default component.exports